import {
  GET_CHANCE_GAMES_RULES_REQUEST,
  GET_CHANCE_GAMES_RULES_SUCCESS,
  GET_CHANCE_GAMES_RULES_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isFetched: false,
  isLoading: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CHANCE_GAMES_RULES_REQUEST:
      return { ...state, isLoading: true, error: null, isFetched: false };
    case GET_CHANCE_GAMES_RULES_SUCCESS:
      return { ...state, data: action.payload, isFetched: true, isLoading: false, error: null };
    case GET_CHANCE_GAMES_RULES_FAILURE:
      return { ...state, isFetched: true, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
